import * as React from 'react';

type Props = {
  danger?: boolean;
  icon?: string;
  selected?: boolean;
  onBlack?: boolean;
  primary?: boolean;
  padding?: string;
} & React.HTMLProps<HTMLButtonElement>;

export default class extends React.Component<Props> {
  render() {
    let icon: React.ReactNode;
    if (this.props.icon) {
      const iconName = `${this.props.icon}${
        this.props.selected ? '-selected' : ''
      }.svg`;
      const maskImage = `url(/media/icons/action-button/${iconName})`;
      icon = <i style={{ maskImage, WebkitMaskImage: maskImage }} />;
    }
    let className = 'action-button';
    if (this.props.primary) {
      className += ' action-button--primary';
    }
    if (this.props.selected) {
      className += ' action-button--selected';
    }
    if (this.props.danger) {
      className += ' action-button--danger';
    }
    if (this.props.onBlack) {
      className += ' action-button--onBlack';
    }
    return (
      <button
        className={className}
        onClick={this.props.onClick}
        style={{ padding: this.props.padding }}
        disabled={this.props.disabled}
      >
        {icon}
        {this.props.children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/components/ActionButton.tsx